'use strict';

function waitOnEvent({ doneCheck, callback, fallback }) {
  const waitsLeft = [50, 150, 350, 750];

  const waiter = () => {
    if (doneCheck()) {
      return callback();
    }

    const wait = waitsLeft.shift();
    if (wait) {
      return setTimeout(() => waiter({ doneCheck, callback, fallback }), wait);
    }

    return fallback();
  };

  waiter();
}

module.exports = {
  waitOnEvent,
};
